import script from "./DescontosAlunos.vue?vue&type=script&setup=true&lang=js"
export * from "./DescontosAlunos.vue?vue&type=script&setup=true&lang=js"

import "./DescontosAlunos.vue?vue&type=style&index=0&id=605a9db8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605a9db8"]])

export default __exports__